export default "__VITE_ASSET__c0ae89cd__"